import { render, staticRenderFns } from "./ArtistView.vue?vue&type=template&id=5b1e6d66&scoped=true"
import script from "./ArtistView.vue?vue&type=script&lang=js"
export * from "./ArtistView.vue?vue&type=script&lang=js"
import style0 from "./ArtistView.vue?vue&type=style&index=0&id=5b1e6d66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1e6d66",
  null
  
)

export default component.exports